
<div class="modal-header">Edit Incident</div>
<div class="p-2">
  <div class="mb-2">
    <label class="form-label">Name</label>
    <input type="text" class="form-control" placeholder="Incident name" [(ngModel)]="name" />
  </div>

  <div class="mb-2">
    <label class="form-label">Description</label>
    <textarea rows="3" class="form-control" placeholder="Incident description" [(ngModel)]="description"></textarea>
  </div>

  @if (isGeofenceIncident) {
    <div class="mt-3">
      <div class="mb-2 d-flex align-items-center justify-content-between">
        <div><strong>Medium Geometry</strong></div>
        <div>
          @if (hasMedGeo) {
            <button type="button" class="btn btn-outline-primary btn-sm me-1" (click)="editMediumGeometry()">
              <i class="fa fa-edit"></i> Edit
            </button>
          }
          @if (!hasMedGeo) {
            <button type="button" class="btn btn-outline-primary btn-sm" (click)="addMediumGeometry()">
              <i class="fa fa-plus"></i> Add
            </button>
          }
        </div>
      </div>
      <div class="mb-2 d-flex align-items-center justify-content-between">
        <div><strong>Low Geometry</strong></div>
        <div>
          @if (hasLowGeo) {
            <button type="button" class="btn btn-outline-primary btn-sm me-1" (click)="editLowGeometry()">
              <i class="fa fa-edit"></i> Edit
            </button>
          }
          @if (!hasLowGeo) {
            <button type="button" class="btn btn-outline-primary btn-sm" (click)="addLowGeometry()">
              <i class="fa fa-plus"></i> Add
            </button>
          }
        </div>
      </div>
    </div>
  }

  <div class="row mt-3">
    <div class="col-3"></div>
    <div class="col-3">
      <button type="button" class="btn btn-danger w-100" (click)="ok()">Submit</button>
    </div>
    <div class="col-3">
      <button type="button" class="btn btn-secondary w-100" (click)="cancel()">Cancel</button>
    </div>
    <div class="col-3"></div>
  </div>
</div>